import generateLocaleAwarePolicyIndex from '../../utils';
import SLICE_NAMESPACE from '../types';
import NAMESPACE from './types';

function _dataSelector(state) {
    return state[SLICE_NAMESPACE][NAMESPACE];
}

function selectTCContent(appState, params) {
    const index = typeof params === 'string'
        ? params
        : generateLocaleAwarePolicyIndex(params);

    return _dataSelector(appState)[index];
}

export {
    selectTCContent,
};
